(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["santa-express-home"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  if (!document.getElementById('sx-fonts')) {
    var link = document.createElement('link');
    link.id = 'sx-fonts'; link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Inter:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
